import { json } from "@sveltejs/kit";
const version = "1.4.0";
const pkg = {
  version
};
async function GET() {
  return json({ version: pkg.version });
}
export {
  GET
};
